export const CHUNK_RELOAD_STORAGE_KEY = 'gcv-chunk-reloaded';
export const CHUNK_RELOAD_WINDOW_MS = 5 * 60 * 1000;
